import { type ActionCreator, on, type ReducerTypes } from '@ngrx/store';
import { produce } from 'immer';

import { type EngineStateBase } from '../engine-store';

import { updateChatWorkflows, updateChatWorkflowsSuccess } from './chat.actions';

export const chatReducerTypes: ReducerTypes<EngineStateBase, ActionCreator[]>[] = [
  on(updateChatWorkflows, (state, { workflows, connection }) =>
    produce(state, (draft) => {
      if (connection) {
        draft.connections.push(connection);
      }

      for (const workflow of workflows) {
        const ix = draft.workflows.findIndex((w) => w.id === workflow.id);
        if (ix !== -1) {
          draft.workflows[ix] = workflow;
        }
      }
    }),
  ),
  on(updateChatWorkflowsSuccess, (state, { workflows }) =>
    produce(state, (draft) => {
      for (const workflow of workflows) {
        const ix = draft.workflows.findIndex((w) => w.id === workflow.id);
        if (ix !== -1) {
          draft.workflows[ix] = workflow;
        }
      }
    }),
  ),
];
